"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _core = _interopRequireDefault(require("./core"));

var EventDispatcher = /*#__PURE__*/function () {
  function EventDispatcher() {
    (0, _classCallCheck2["default"])(this, EventDispatcher);
    this.listeners = {};
  }

  (0, _createClass2["default"])(EventDispatcher, [{
    key: "addListener",
    value: function addListener(eventsName, callback, context) {
      var _this = this;

      for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var listener = {
        callback: callback,
        context: context,
        args: args
      };

      _core["default"].each(eventsName.split(','), function (i, eventName) {
        eventName = eventName.trim();

        if (_this.hasListener(eventName)) {
          _this.listeners[eventName].push(listener);
        } else {
          _this.listeners[eventName] = [listener];
        }
      });
    }
  }, {
    key: "dispatch",
    value: function dispatch(eventsName) {
      var _this2 = this;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _core["default"].each(eventsName.split(','), function (i, eventName) {
        eventName = eventName.trim();

        if (_this2.hasListener(eventName)) {
          _core["default"].each(_this2.listeners[eventName], function (i, listener) {
            return listener.callback.apply(listener.context, [eventName].concat(listener.args).concat(args));
          });
        }
      });
    }
  }, {
    key: "hasListener",
    value: function hasListener(eventName, callback, context) {
      if (_core["default"].isUndefined(callback)) {
        return !_core["default"].isUndefined(this.listeners[eventName]);
      }

      return !!_core["default"].map(this.listeners[eventName], function (i, listener) {
        return listener.callback === callback && listener.context === context ? true : null;
      }).length;
    }
  }, {
    key: "removeListener",
    value: function removeListener(eventName, callback, context) {
      var _this3 = this;

      if (this.hasListener(eventName, callback, context)) {
        if (_core["default"].isUndefined(callback)) {
          this.listeners[eventName].splice(0);
        } else {
          _core["default"].each(this.listeners[eventName], function (i, listener) {
            if (listener.callback === callback && context === context) {
              _this3.listeners[eventName].splice(i, 1);

              return false;
            }
          });
        }
      }
    }
  }]);
  return EventDispatcher;
}();

;
var eventDispatcher = new EventDispatcher();
_core["default"].EventDispatcher = eventDispatcher;
var _default = eventDispatcher;
exports["default"] = _default;